// extracted by mini-css-extract-plugin
export default {"pomodoro":"pomodoro_pomodoro__jMGf8","buttons-container":"pomodoro_buttons-container__YKfAG"};